export default {
  slots: {
    base: 'cursor-pointer',
    label: 'cursor-pointer',
  },
}